"use client";

import { useState, useEffect } from "react";
import Button from "../Button";
import { useContent } from "../../content/current";


export default function EquipoMobile() {
  const content = useContent();
  const TEAM_MEMBERS = content.team.members;
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    if (openIndex === null) return;
    const handleClose = (e) => {
      if (e.target.closest(".equipobtnwrap")) return;
      setOpenIndex(null);
    };
    document.addEventListener("click", handleClose);
    return () => document.removeEventListener("click", handleClose);
  }, [openIndex]);

  return (
    <section id="equipo" className="equipomobile">
      <h2 className="equipotitle" dangerouslySetInnerHTML={{ __html: content.team.title }} />
      <div className="equipomobilewrap">
        {TEAM_MEMBERS.map((member, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={member.image}
              className={`equipoitem${isOpen ? " is-open" : ""}`}
            >
              <div className="equipoitemcont">
                <img
                  src={member.image}
                  alt={member.name}
                  width="500"
                  height="500"
                  decoding="async"
                />
                <div className="equipobtnwrap">
                  <Button
                    onClick={() =>
                      setOpenIndex((prev) => (prev === index ? null : index))
                    }
                  >
                    {member.name}
                  </Button>
                </div>
                <div
                  className="equipobio"
                  onClick={isOpen ? () => setOpenIndex(null) : undefined}
                >
                  <span className="equipobiorole">
                    <strong>{member.role}</strong>
                  </span>
                  <p>{member.bio}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
